import { render, staticRenderFns } from "./ReservationOrder.vue?vue&type=template&id=31a5dce3&scoped=true&"
import script from "./ReservationOrder.vue?vue&type=script&lang=js&"
export * from "./ReservationOrder.vue?vue&type=script&lang=js&"
import style0 from "./ReservationOrder.vue?vue&type=style&index=0&id=31a5dce3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5dce3",
  null
  
)

export default component.exports